import { render } from "./ComingSoon.vue?vue&type=template&id=4ccd36a2&scoped=true"
import script from "./ComingSoon.vue?vue&type=script&lang=js"
export * from "./ComingSoon.vue?vue&type=script&lang=js"

import "./ComingSoon.vue?vue&type=style&index=0&id=4ccd36a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ccd36a2"

export default script